import { gql } from 'apollo-boost';
import { addDaysToDate, getFirstMonthDay, getLastMonthDay } from 'core/utils';
import { useCallback, useEffect } from 'react';
import { ViewCallbackProperties } from 'react-calendar';
import { useGetCourseCalenderDataLazyQuery } from 'site/graphql';

gql`
    query GetCourseCalenderData($filter: OrderListRequest) {
        extendedOrders(filter: $filter) {
            count
            result {
                id
                courseDate
                courseTitle
                courseHours
                productName
                state
                productId
                productName
            }
        }
    }
`;

const useAccountCourseCalendar = () => {
    // Нельзя использовать useGetCourseCalenderDataQuery, т.к. Apollo при SSR вызывает рендер
    // 2 раза, с-но new Date() постоянно разный, из-за этого происходит зацикливание
    const [fetch, { data, loading }] = useGetCourseCalenderDataLazyQuery();
    const orders = (data && data.extendedOrders && data.extendedOrders.result) || [];

    useEffect(() => {
        fetch({
            variables: {
                filter: {
                    courseStartDate: addDaysToDate(getFirstMonthDay(new Date()), -7).toISOString(),
                    courseEndDate: addDaysToDate(getLastMonthDay(new Date()), 7).toISOString(),
                    full: true,
                    onlyCourses: true,
                },
            },
        });
    }, [fetch]);

    const handleViewChange = useCallback(
        ({ activeStartDate, view }: ViewCallbackProperties) => {
            switch (view) {
                case 'month':
                    fetch({
                        variables: {
                            filter: {
                                courseStartDate: addDaysToDate(activeStartDate, -7).toISOString(), // самый плохой вариант первое число - воскресенье
                                courseEndDate: addDaysToDate(activeStartDate, 38).toISOString(), // самый плохой вариант последнее число(31) - понедельник
                                full: true,
                                onlyCourses: true,
                            },
                        },
                    });
                    break;
                case 'year':
                    fetch({
                        variables: {
                            filter: {
                                courseStartDate: activeStartDate.toISOString(),
                                courseEndDate: addDaysToDate(activeStartDate, 366).toISOString(),
                                full: true,
                                onlyCourses: true,
                            },
                        },
                    });
                    break;
                case 'decade':
                    fetch({
                        variables: {
                            filter: {
                                courseStartDate: activeStartDate.toISOString(),
                                courseEndDate: addDaysToDate(activeStartDate, 366 * 12).toISOString(),
                                full: true,
                                onlyCourses: true,
                            },
                        },
                    });
                    break;
                default:
                    break;
            }
        },
        [fetch],
    );

    return [orders, loading, handleViewChange] as const;
};

export default useAccountCourseCalendar;
